import { EmblaViewportRefType } from "embla-carousel-react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { ScratchInstructions } from "utils/interfaces";

interface ParagraphsCarouselProps {
  emblaRef: EmblaViewportRefType;
  instructions: ScratchInstructions[];
  selectedIndex: number;
}

const ParagraphsCarousel: React.FC<ParagraphsCarouselProps> = ({
  emblaRef,
  instructions,
  selectedIndex,
}) => {
  return (
    <div className="relative w-full h-full">
      <div ref={emblaRef} className="absolute inset-0 overflow-y-hidden">
        <div className="w-full h-full flex flex-col gap-2">
          {instructions ? (
            instructions.map(
              (instruction: ScratchInstructions, index: number) => {
                return (
                  <div
                    key={index}
                    className="w-full flex-col justify-start items-start gap-4 inline-flex" //min-h-[calc(100%-30px)]
                    style={{
                      minHeight:
                        index === instructions.length - 1
                          ? "100%"
                          : "calc(100% - 30px)",
                    }}
                  >
                    <div
                      className={`h-fit ${
                        index === selectedIndex
                          ? "text-neutral-700"
                          : "text-neutral-700/20"
                      } text-[19px] font-semibold font-poppins leading-[23px]`}
                    >
                      {index + 1}. {instruction.header}
                    </div>
                    <div className="w-full flex-grow overflow-y-auto custom-scroll">
                      <Markdown
                        className="instructions-md"
                        remarkPlugins={[remarkGfm]}
                        components={{
                          code({ node, className, children, ...props }) {
                            return (
                              <code
                                className="h-[21px] px-1 py-0.5 bg-accent-600 rounded items-center gap-2 inline-flex text-white text-sm font-normal font-['JetBrains Mono'] leading-none"
                                {...props}
                              >
                                {children}
                              </code>
                            );
                          },
                        }}
                      >
                        {instruction.paragraph}
                      </Markdown>
                    </div>
                  </div>
                );
              }
            )
          ) : (
            <div className="w-full h-full" />
          )}
        </div>
      </div>
    </div>
  );
};

export default ParagraphsCarousel;
